import React from 'react';
import Logo from '../../assets/svg/tap-logo.svg';
import { Image } from 'antd';

const MaintenanceModeWrapper = () => (
    <div id="page-body" className="interaction-page page-body js-index">
        <div className="maintenance-container">
            <div className="maintenance-logo">
                <Image src={Logo} alt="Logo" />
            </div>
            <div className="maintenance-description">
                <p className="maintenance-description-title">We'll be back soon</p>
                <p className="maintenance-description-text">
                    The Ambassador Platform is down for scheduled maintenance and expect to be back online soon.
                </p>
                <p>You can always reach out to our customer support team</p>
                <p className="maintenance-description-email">support@theambassadorplatform.com</p>
            </div>
            <div className="maintenance-description-footer">The Ambassador Platform Limited</div>
        </div>
    </div>
);

export default MaintenanceModeWrapper;
